import type { ReactNode } from 'react';
import { APP_VERSION, SUPPORT_LABEL, SUPPORT_URL } from 'constants/app-info';
import styles from './auth-layout.module.scss';

/**
 * "© 2026 HP Media · Hỗ trợ · Phiên bản 0.1.0". Link Hỗ trợ chỉ hiện khi có
 * REACT_APP_SUPPORT_URL (không bịa kênh hỗ trợ); phiên bản là REACT_APP_VERSION nếu đặt,
 * không thì hằng DEFAULT_APP_VERSION (xem constants/app-info.ts).
 */
const AuthFooter = () => {
  const parts: ReactNode[] = [`© ${new Date().getFullYear()} HP Media`];
  if (SUPPORT_URL) {
    const external = /^https?:/i.test(SUPPORT_URL);
    parts.push(
      <a href={SUPPORT_URL} {...(external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}>
        {SUPPORT_LABEL}
      </a>
    );
  }
  if (APP_VERSION) parts.push(`Phiên bản ${APP_VERSION}`);

  return (
    <footer className={styles.footer}>
      {parts.map((part, index) => (
        <span key={index}>
          {index > 0 && (
            <span aria-hidden="true" className={styles.footerDot}>
              ·
            </span>
          )}
          {part}
        </span>
      ))}
    </footer>
  );
};

export default AuthFooter;
